import React, { useEffect, useRef, forwardRef } from 'react'
import { DragOutlined } from '@ant-design/icons'

import { renderTranslation } from '../../../Helpers/GenericHelpers'
import { TranslationKeys } from '../../../Constants/TranslationKeys'
import {
  AvailabilitiesSelectValue,
  movementSectionContainer,
  movementSectionId,
} from '../../../Constants/Configuration'
import MovementsAndAvailabilities from './MovementsAndAvailabilities'
import { useAppSelector } from '../../../hooks'

function MovementsAndAvailabilitiesGridLayout(
  { style, className, onMouseDown, onMouseUp, onTouchEnd, children, ...props },
  ref,
) {
  const language = useAppSelector(state => state.present.language.value)
  const articleSelected = useAppSelector(state => state.present.articleDetail.articleSelected)
  const movementTabVisible = useAppSelector(state => state.present.configuration.isTabMovementVisible)
  const workspaceMovementVisible = useAppSelector(state => state.present.configuration.workspaceMovementVisible)
  const availabilityTabVisible = useAppSelector(state => state.present.configuration.isTabAvailabilityVisibile)
  const workspaceAvailabilityVisible = useAppSelector(state => state.present.configuration.workspaceAvailabilityVisible)
  const enableMovements = useAppSelector(state => state.present.movementsAvailabilities.value.enableMovements)

  const movementBoxDomElementRef = useRef(null)

  const isAvailabilitiesFetched = articleSelected.fetchedAvailabilites
  const isMovementsFetched = articleSelected.fetchedMovements

  const emptyClass = (enableMovements === AvailabilitiesSelectValue ? isAvailabilitiesFetched : isMovementsFetched)
    ? ''
    : ' emptyBar'

  const isMovementBoxVisible =
    (movementTabVisible && workspaceMovementVisible) || (availabilityTabVisible && workspaceAvailabilityVisible)

  useEffect(() => {
    const movementRef = movementBoxDomElementRef.current
    movementBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.observe(movementRef)

    return () => {
      movementBoxDomElementRef && props.domElementsRefObserver && props.domElementsRefObserver.unobserve(movementRef)
    }
  }, [props.domElementsRefObserver, movementBoxDomElementRef])

  useEffect(() => {
    //essential for first render to match container width
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 500)
  }, [])

  return (
    <div
      id={movementSectionId}
      grid-data={props.datagrid}
      className={
        className + (!isMovementBoxVisible || (!isMovementsFetched && !isAvailabilitiesFetched) ? ' d-none' : '')
      }
      style={{ ...style }}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onTouchEnd={onTouchEnd}
    >
      <div className='grid-layout-adjust-wrapper'>
        <div className='drag-handle-grid-container'>
          <DragOutlined />
        </div>
        <div className='diwa-container' ref={movementBoxDomElementRef} id={movementSectionContainer}>
          <div className={`label-drag${emptyClass}`}>
            {renderTranslation(language, TranslationKeys.buttonMovementsSection)}
          </div>
          <MovementsAndAvailabilities />
        </div>
      </div>
    </div>
  )
}

export default forwardRef(MovementsAndAvailabilitiesGridLayout)
